export const apolloErrorMe = "pages/settings/account/change/password/ApolloError/me";
export const apolloErrorVerifyPassword = "pages/settings/account/change/password/ApolloError/verifyPassword";
export const apolloErrorDoRenewPassword = "pages/settings/account/change/password/ApolloError/doRenewPassword";
